module.exports = __webpack_public_path__ + "img/15.bca0f514.gif";